export function GonjongMark({ className = 'h-9 w-9' }) {
  return (
    <svg viewBox="0 0 48 40" className={className} fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M6 33 Q 9 13 24 4 Q 13 19 15 33 Z" />
      <path d="M42 33 Q 39 13 24 4 Q 35 19 33 33 Z" />
      <rect x="4" y="33" width="40" height="4" rx="2" />
    </svg>
  );
}

export function GonjongSilhouette({ className = '' }) {
  return (
    <svg viewBox="0 0 200 70" className={className} fill="currentColor" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMax meet">
      <path d="M10 66 Q 22 24 56 8 Q 34 38 38 66 Z" />
      <path d="M62 66 Q 72 34 100 22 Q 80 48 84 66 Z" />
      <path d="M138 66 Q 128 34 100 22 Q 120 48 116 66 Z" />
      <path d="M190 66 Q 178 24 144 8 Q 166 38 162 66 Z" />
      <rect x="4" y="64" width="192" height="6" rx="3" />
    </svg>
  );
}

export function PaluangStack({ className = '' }) {
  const plates = [
    { cy: 188, rx: 88 },
    { cy: 150, rx: 80 },
    { cy: 112, rx: 72 },
    { cy: 74, rx: 64 },
    { cy: 38, rx: 56 },
  ];
  return (
    <svg viewBox="0 0 200 216" className={className} aria-hidden="true" focusable="false">
      {plates.map((p, i) => (
        <g key={i}>
          <ellipse cx="100" cy={p.cy} rx={p.rx} ry="17" fill="none" stroke="currentColor" strokeWidth="2" opacity={0.35 + i * 0.16} />
          <ellipse cx="100" cy={p.cy - 5} rx={p.rx - 14} ry="10" fill="none" stroke="currentColor" strokeWidth="1.4" opacity={0.25 + i * 0.16} />
        </g>
      ))}
    </svg>
  );
}

export function SongketDivider({ light = false }) {
  return <div className={light ? 'songket-strip-light w-full' : 'songket-strip w-full'} aria-hidden="true" />;
}
